import { defineComponent as _defineComponent } from 'vue'
import { SHARE_ENTRY_INFO } from '@/config/wx-share-config';
import { useWxShare } from '@/hooks/use-wx-share';
import { ShareVue } from '@tencent/wphk-act-base-components';
import { computed, onMounted } from 'vue';
import { showToast } from '@tencent/wphk-components-toast';
import { useShowShare } from './hooks/use-show-share';
import { userEnv } from '@tencent/wphk-base-utils';
import { i18n } from '@/i18n';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { isShowShare, hideShare } = useShowShare();
const { copyContent } = useWxShare();
const guideWxImg = computed(() => (userEnv.isInMiniProgram() ? i18n('guideMpImgUrl') : i18n('guideWxImgUrl')));
const entryInfo = computed(() => ({
  ...SHARE_ENTRY_INFO,
  copyContent: copyContent.value,
  clickCopyCb: () => {
    showToast({
      title: i18n('複製成功！'),
      duration: 1000,
    });
    hideShare();
    return true;
  },
}));
const onClose = (arg: any) => {
  hideShare();
  console.log('====onClose arg', arg);
};
onMounted(() => {
  // 通用设置微信分享
  useWxShare();
});

return { __sfc: true,isShowShare, hideShare, copyContent, guideWxImg, entryInfo, onClose, ShareVue }
}

})